import React, { useEffect } from 'react';

const LOGIN_URL = 'https://partner.activikid.hk/partner-login';

function PartnerLoginPage() {
  useEffect(() => {
    window.location.replace(LOGIN_URL);
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#fff',
    }}>
      <img
        src="/Images/loading-cat.png"
        alt="Loading"
        style={{ width: '280px', maxWidth: '60vw' }}
      />
      <p style={{ color: '#888', fontSize: '1.6rem', marginTop: '1.2rem', fontWeight: 500 }}>
        Redirecting...
      </p>
    </div>
  );
}

export default PartnerLoginPage;
